import { Component, computed, input } from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { tablerCircleCheckFill } from '@ng-icons/tabler-icons/fill';
import { Loader } from '../loader';

export type ReasoningTaskStatus = 'completed' | 'in-progress';

export interface ReasoningTask {
  title: string;
  description: string | null;
  status: ReasoningTaskStatus;
}

@Component({
  selector: 'reasoning-task-list',
  templateUrl: './reasoning-task-list.html',
  styleUrl: './reasoning-task-list.scss',
  imports: [NgIcon, Loader],
  providers: [provideIcons({ tablerCircleCheckFill })],
  host: {
    '[class.active]': 'active()',
  },
})
export class ReasoningTaskList {
  readonly tasks = input.required<ReasoningTask[]>();
  readonly active = input(false);

  readonly statusLabels: Record<ReasoningTaskStatus, string> = {
    completed: 'Completed',
    'in-progress': 'In progress',
  };

  readonly hasActive = computed(() => this.tasks().some((t) => t.status === 'in-progress'));
}
